import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { prefix } from '../../../tools/settings';
import cx from 'classnames';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledDescription = styled.div.withConfig({
  displayName: "Description__StyledDescription",
  componentId: "sc-4w0do0-0"
})(["color:var(--dentsu-color-n1000);font-size:var(--dentsu-font-size-14);font-weight:var(--dentsu-font-weight-regular);word-break:break-word;"]);
var Description = forwardRef(function (_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx(_defineProperty({}, "".concat(prefix, "-card__description"), true));
  return _jsx(StyledDescription, _objectSpread(_objectSpread({
    ref: ref,
    className: className
  }, rest), {}, {
    children: children
  }));
});
export default Description;